import { render, staticRenderFns } from "./ShowroomWsChips001.vue?vue&type=template&id=c49aad14"
import script from "./ShowroomWsChips001.vue?vue&type=script&lang=js"
export * from "./ShowroomWsChips001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports